import { Settings } from "../../../Settings";
import NumberFormatter from "../../../util/NumberFormatter";
import Totals from "../../crew/Totals";
import Values from "../../value/Values";
import SkillNode from "../SkillNode";

export default class OreBonusSkillNode extends SkillNode {
    /**
     * @param {string} id 
     * @param {string} description 
     * @param {Totals} totals
     * @param {string} iconFileName 
     * @param {BigNum} cost 
     * @param {Values} values
     */
    constructor(id, totals, iconFileName, cost, purchaseListener, values) {
        super(id, 'Ore x' + Settings.skill.bonus.oreBonusMultiplierPerUpgrade, null, totals, 
            iconFileName, cost, purchaseListener);

        /**
         * @constant
         * @type {Values}
         */
        this.values = values;
    }

    /**
     * @returns {string}
     */
    getDescription() {

        // let displayBonus;
        // const bonus = this.values.skillOreBonusMultiplier.getValue();
        // if (bonus.equalsZero()) {
        //     displayBonus = 1;
        // }
        // else {
        //     displayBonus = bonus;
        // }

        return 'Bonus: x' + NumberFormatter.formatBigNum(this.values.skillOreBonusMultiplier.getValue());
    }

    /**
     * @override
     */
    onPurchase() {
        if (super.onPurchase()) {
            this.applyMultipliers();
            return true;
        }
        else {
            return false;
        }
    }

    /**
     * @override
     */
    onPurchaseFromSave() {
        this.applyMultipliers();
        super.onPurchaseFromSave();
    }

    /**
     * @private
     */
    applyMultipliers() {
        // const val = Math.max(1, this.values.skillOreBonusMultiplier.getValue());
        // this.values.skillOreBonusMultiplier.setValue(Settings.skill.bonus.oreBonusMultiplierPerUpgrade * val);

        // BigNum version:
        const val = this.values.skillOreBonusMultiplier.getValue(); //  Math.max(1, this.values.skillOreBonusMultiplier.getValue());
        
        // The value starts off at 0, so check for this and make it start at 1.
        if (val.lessThanEqualsNumber(1)) {
            val.setValue(1);
        }

        val.mulNumber(Settings.skill.bonus.oreBonusMultiplierPerUpgrade);

        /////this.values.skillOreBonusMultiplier.setValue(val);
    }

}